module.exports = __webpack_public_path__ + "img/jf_home_05.31894ff0.jpg";